export { default } from './InlineTextEditor';

